// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { environmentBase } from './environment.base';

export const environment = {
  ...environmentBase,
  production: false,
  apiServer: 'https://devapi.fullswingapps.com/api/fs',
  hostName: 'devapi.fullswingapps.com',

  appConfigPath: './assets/config/app-config.json',
  defaultPage: 'event',

  //Local strorage values
  navName: '_fs_nav_name',
  bayManagerUser: 'Bay-Manager-User',
  calendarState: '_fs_fc_state',

  langId: '_fs_lang_id',
  defaultLanguage: 'en',
  defaultFontFamily: 'DavisSans',

  breakPointScreen: {
    small: 576,
    Medium: 768,
    large: 992,
    extraLarge: 1200,
    xExtraLarge: 1400,
  },

  launcherVersion: '1.4.0',
  sseLauncherVersion: '1.8.17',
  legacyConnectionsUrl:
    'https://32zlw20y67.execute-api.us-west-2.amazonaws.com/dev/bay-manager-explorer',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
